import {
  Injectable,
  PLATFORM_ID,
  Inject
} from '@angular/core';
import { isPlatformServer, DOCUMENT } from '@angular/common';
import { Observable,BehaviorSubject, Subject } from 'rxjs';

import { TransferState, makeStateKey, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
const FETCH_APP_CONFIG = makeStateKey('fetchAppConfig');
const FETCH_APP_TEMPLATES = makeStateKey('fetchAppTemplates');
@Injectable()
export class SessionService {
  yeloDomain: any;
  private config: any;
  private templates: any = { pages: {}, components: {} };
  private localStorage;
  public countryInfo = new BehaviorSubject({});
  annoucmentWidget: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public permissionDenied = new BehaviorSubject(false);
  public lastOrderRefrenceId = new Subject <any>();
  public walletToPayment;
  public resendOTP;
  public locationTrigger;
  public merchantdetailshippohybrid;
  public hybridredirection;
  addresslabel:string=''
  saveFavId:any;
  intervalGobal:any;
  public noListPageRedirection;
  public languageStrings : any = {};
  public loginmodalshow = new Subject<any>();
  public sendcheckoutagain = new Subject<any>();
  // public wipayWinRef;
  // public curlecWinRef;
  // public payuWinRef;
  // public payMobWinRef;
  // public wirecardWinRef;
  // public sslCommerzWinRef;
  // public fac3dWinRef;
  // public checkoutComWinRef;
  // public vivaComWinRef;
  // public payHereWinRef;
  // public azulWinRef;
  // public credimaxWinRef;
  // public fatoorahWinRef;
  // public tapWinRef;
  // public thetellerWinRef;
  // public paynowWinRef;
  // public hyperPayWinRef;
  // public paynetWinRef;
  public paymentWinRef;
  public thankYouPageHtml;
  public locationObject: any = {
    lat: '',
    lng: '',
    city: ''
  };
  public is_netcore_enabled;
  public langStringsPromise: Promise<boolean> = new Promise(() => { });
  showUpdatePopup: boolean;
  d2c_store_list = [];
  public isMerchantDomain() {
    return (
      this.config &&  this.config.merchant_domain_obj &&
      !!Object.keys(this.config.merchant_domain_obj || {}).length
    );
  }

  public dataCache = new Map();
  constructor(
    @Inject(PLATFORM_ID) private platform,
    private state: TransferState,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private titleService: Title
  ) {
    this.configureConfig();
    this.configureLocalStorage();
    console.log('cookiee', this.getCookie('_lc'));
    if (environment.enable_ssr) {
      let _location: any = this.initialLocation();
      this.set('location', _location);
    }
    this.resetTitle();
  }

  public initialLocation() {
    let _location: any = this.getCookie('_lc');
    try {
      if (_location) {
        _location = JSON.parse(_location);
      } else {
        if (this.isMerchantDomain()) {
          //for merchant domain
          let address =
          this.config && this.config.merchant_domain_obj &&
            this.config.merchant_domain_obj.address === '-'
              ? ''
              : this.config.merchant_domain_obj.address;
          _location = {
            lat: this.config.merchant_domain_obj.latitude,
            lng: this.config.merchant_domain_obj.longitude,
            city: address
          };
        } else {
          //for admin domain
          if(this.get('location') && this.get('location').lat){
            let address = this.get('location').city;
            _location = {
              lat: this.get('location').lat,
              lng: this.get('location').lng,
              city: address
            };
          }else{
            let address = this.config.address === '-' ? '' : this.config.address;
            _location = {
              lat: this.config.latitude,
              lng: this.config.longitude,
              city: address
            };
          }
        }
      }
    } catch (e) {
      console.error('cookie error', e, window['cookie']);
      let address = this.config.address === '-' ? '' : this.config.address;
      _location = {
        lat: this.config.latitude,
        lng: this.config.longitude,
        city: address
      };
    } finally {
      return _location;
    }
  }

  public addToTemplates(templates) {
    // this.templates = {};
    if (templates && templates.page_template && templates.page_template.page_name) {
      // console.log(this.templates.pages);
      this.templates.pages[templates.page_template.page_name] =
        templates.page_template;
      this.templates.components = Object.assign(
        {},
        this.templates.components,
        templates.components
      );
    }
    // this.templates[templates.page_template.page_name] = templates;
  }

  private configureConfig() {
    this.config = this.state.get(FETCH_APP_CONFIG, null as any);
    // if(!this.config && !this.isPlatformServer()) {
    //   alert('This service is not available for you. Please contact admin.');
    //   return;
    // }
    if(environment.enable_ssr){
    this.templates = this.state.get(FETCH_APP_TEMPLATES, null as any);
    }


    if (this.isPlatformServer()) {
      this.config = window['config'].config;
      this.templates = window['config'].templates;
      // console.log(this.config, this.templates, "config and templates");
      this.state.set(FETCH_APP_CONFIG, this.config as any);
      this.state.set(FETCH_APP_TEMPLATES, this.templates as any);
    }
  }

  private configureLocalStorage() {
    if (this.isPlatformServer()) {
      let _location: any = this.initialLocation();
      _location = encodeURIComponent(JSON.stringify(_location));
      this.localStorage = {
        obj: {
          domain: this.config.domain_name,
          language: window['language'] || 'en',
          location: _location
        },
        getItem: function(str) {
          return this.obj[str];
        },
        setItem: function(key, value) {
          if (key === 'location') return;
          this.obj[key] = value;
        },
        removeItem: function(key) {
          if (key === 'location') return;
          delete this.obj[key];
        },
        clear: function() {
          this.obj = {};
        },
        length: 1,
        key: null
      };
    } else {
      this.localStorage = window['localStorage'];
      this.locationObject = JSON.parse(
        decodeURIComponent(this.localStorage.getItem('location'))
      );
    }
  }

  set(key, value) {
    if (key == 'config') {
      this.config = value;
      return;
      // this.setStyles();
    }
    if (key == 'templates') {
      // this.templates = value;
      this.addToTemplates(value);
      return;
      // this.setStyles();
    } else if (key == 'location') {
      //set cookie for location
      this.locationObject = value;
      if (!this.isPlatformServer()) {
        document.cookie = `_lc=${encodeURIComponent(
          JSON.stringify(value)
        )}; expires=Thu, 4 Feb 2021 12:00:00 UTC; path=/`;
      }
    }
    value = JSON.stringify(value);
    value = encodeURIComponent(value);
    this.localStorage.setItem(key, value);
  }
  setString(key, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    this.localStorage.setItem(key, value);
  }

  setToString(key, value) {
    //value = value;
    this.localStorage.setItem(key, value);
  }

  setSessionItem(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionItem(key: string): any {
    const item = sessionStorage.getItem(key);
    try {
      if(typeof item === 'string'){
        return JSON.parse(item);
      }
      return item;
    } catch (error) {
      console.error('Error parsing session item', error);
    }
  }

  removeSessionItem(key: string) {
    sessionStorage.removeItem(key);
  }

  get(key): any {
    if (key == 'config') return JSON.parse(JSON.stringify(this.config));

    if (key == 'templates') return JSON.parse(JSON.stringify(this.templates));
    if (key == 'location')
      return JSON.parse(JSON.stringify(this.locationObject));
    // if (key == "config") this.config;

    if (this.localStorage.getItem(key)) {
      let data = decodeURIComponent(this.localStorage.getItem(key));
      data = JSON.parse(data);
      return data;
    } else {
      return null;
    }
  }
  getString(key): string {
    if (key === 'domain' && this.config) {
      return this.config.domain_name;
    }

    if (this.localStorage.getItem(key)) {
      let data = this.localStorage.getItem(key);
      return data;
    } else {
      return null;
    }
  }
  setByKey(parentKey, childKey, value) {
    let appObj: any = this.get(parentKey);
    if (!appObj) {
      appObj = {};
    }
    appObj[childKey] = value;
    this.set(parentKey, appObj);
  }
  getByKey(parentKey, childKey, subkey: any = false) {
    const appObj: any = this.get(parentKey);
    if (appObj) {
      if (subkey) {
        return appObj[childKey][subkey];
      } else {
        return appObj[childKey];
      }
    } else {
      return appObj;
    }
  }
  removeByChildKey(parentKey, childKey) {
    const appObj: any = this.get(parentKey);
    if (appObj && typeof appObj === 'object') {
      delete appObj[childKey];
      this.set(parentKey, appObj);
    }
  }
  remove(key) {
    this.localStorage.removeItem(key);
  }
  removeAll() {
    this.localStorage.clear();
  }

  isPlatformServer() {
    return isPlatformServer(this.platform);
  }
  ismobiledevice(){
    let websitePath;
    if(!this.isPlatformServer()){
      websitePath = window.location.pathname.split('/');
    }
    if( (websitePath && window.innerWidth < 768 && this.config &&  this.config.is_mobile_new_layout_enable && !this.config.theme_enabled && !(this.config.onboarding_business_type == 805))){
return true
    }else{
      return false
    }
  }
  // private setStyles() {
  //   // !isPlatformServer(this.platform) ?
  //     this._document.documentElement.style.setProperty(`--blue`, this.get('config').color);// : '';
  // }

  getCookie(cname) {
    var name = cname + '=';
    var decodedCookie;
    if (this.isPlatformServer())
      decodedCookie = decodeURIComponent(window['cookie']);
    else decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  resetTitle() {
    this.titleService.setTitle(
      this.get('config') && this.get('config').form_name
        ? this.get('config').form_name
        : ''
    );
  }

  sortBy(key) {
    return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
  }
checkForYeloDomains(domain){
     this.yeloDomain = ["yelo.red", "taxi-hawk.com"]
    domain = domain.split(".").splice(-2).join(".");
    if(this.yeloDomain.indexOf(domain)>-1){
    return true;
    }
    return false;
    }
    
  defineLangLocale(language?){
    language = language ? language : this.getString('language');
      if (language && language !== 'es' && environment.SSR_Langs.includes(language))
        {
        return 'en';
      }
      else {
        return language;
      }
  }
  //open external link for hybrid apps
  openExternalLink(link){
    window.location.href = "https://externalLink.yelo.red" + '?url=' + link;
  }
  openPaymentLink(link){
    window.location.href = this.get('is_redirection_url_allowed')?"https://paymentLink.yelo.red" + '?url=' + link:"https://paymentLink.yelo.red" + '?url=' + link + '&redirected_url=' + window.location.href;
  }
  //login verification and call of checkout function again
  sendlogin(message: string){
    this.loginmodalshow.next({ text: message });
  }

 // after login got update from checkout 
  getloginUpdate(): Observable<any> { 
    return this.loginmodalshow.asObservable(); 
  }

//if login verification completes send update 
  sendcheckoutChange(message: string){
    this.sendcheckoutagain.next({ text: message });
  }
  
  //after login component sends update changes received
  getcheckoutChange() : Observable<any>{
    return this.sendcheckoutagain.asObservable();
  }

  scrolltotop(){
    if (!this.isPlatformServer()) {
      setTimeout(() => {
        if (document.getElementById("refElement")) {
          document.getElementById("refElement").scrollIntoView({
            behavior: "smooth",
            block: "end"
          });
        }
      }, 0);
    }
  }
  bannerClickScroll(){
      this.intervalGobal = setInterval( () => {
        const profileDropOpen = document.getElementsByClassName('open');
        let openDrop = (profileDropOpen && profileDropOpen[0]) ? true :false;
        const DropDown = openDrop ? (document.getElementsByClassName(profileDropOpen[0].className)[0]).getElementsByClassName('dropdown-toggle')[0] as HTMLElement : null ;
        if(document.getElementById('click-event')){
          document.getElementById('click-event').click();
        }
        // if(openDrop && DropDown){
        //    DropDown.click();
        // }
      },7000);
  }
  // homeView === Brew Sage THEME
  homeViewTheme(){
    return false;
  }
}
